import { render, staticRenderFns } from "./Close.vue?vue&type=template&id=9c58bb3e&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Close.vue"
export default component.exports